import PropTypes from 'prop-types';

import styles from './CalendarTimeSlotsIntro.scss';

export const CalendarTimeSlotsIntro = ({ shopName, duration }) => (
  <div className={styles.CalendarTimeSlotsIntro} data-testid="CalendarTimeSlotsIntro">
    <p>
      Your Design consultation at home will be carried out by specialists from
      {` ${shopName}.`}
    </p>
    <p>
      Your appointment will last
      {` ${duration}.`} We&apos;ll be in touch to confirm our arrival time.
    </p>
    <p>
      <strong>Time Slots:</strong> Morning: 9am - 1pm, Afternoon: 1pm - 5pm, Evening: After 5pm
      (varies by shop)
    </p>
  </div>
);

CalendarTimeSlotsIntro.propTypes = {
  shopName: PropTypes.string.isRequired,
  duration: PropTypes.string.isRequired,
};
